import apiClient from './client';

export const settingsApi = {
  // Profile Settings
  getProfile: () => apiClient.get('/api/profile'),

  updateProfile: (data) => apiClient.put('/api/profile', data),

  uploadProfileImage: (formData) =>
    apiClient.post('/api/profile/image', formData, {
    }),

  // Password Management
  changePassword: (data) => apiClient.put('/api/change-password', data),

  // WhatsApp Profile
  getWhatsAppProfile: () => apiClient.get('/api/whatsapp/profile'),

  updateWhatsAppProfile: (data) => apiClient.put('/api/whatsapp/profile', data),

  // Webhook Settings
  getWebhooks: () => apiClient.get('/api/webhooks'),

  createWebhook: (data) => apiClient.post('/api/webhooks', data),

  updateWebhook: (id, data) => apiClient.put(`/api/webhooks/${id}`, data),

  deleteWebhook: (id) => apiClient.delete(`/api/webhooks/${id}`),

  testWebhook: (id) => apiClient.post(`/api/webhooks/${id}/test`),

  // API Token Management
  getTokens: () => apiClient.get('/api/api-tokens'),

  createToken: (data) => apiClient.post('/api/api-tokens', data),

  updateToken: (id, data) => apiClient.put(`/api/api-tokens/${id}`, data),

  deleteToken: (id) => apiClient.delete(`/api/api-tokens/${id}`),

  regenerateToken: (id) => apiClient.post(`/api/api-tokens/${id}/regenerate`),

  // Facebook Settings
  getFacebookDetails: () => apiClient.get('/api/facebook/details'),

  updateFacebookDetails: (data) => apiClient.put('/api/facebook/details', data),

  connectFacebookPage: (data) => apiClient.post('/api/facebook/connect', data),

  disconnectFacebookPage: (pageId) => apiClient.post('/api/facebook/disconnect', { pageId }),

  // General Settings
  getSettings: () => apiClient.get('/api/settings'),

  updateSettings: (data) => apiClient.put('/api/settings', data),

  // Notification Settings
  getNotificationSettings: () => apiClient.get('/api/settings/notifications'),

  updateNotificationSettings: (data) => apiClient.put('/api/settings/notifications', data),
};

export default settingsApi;
